// extracted by mini-css-extract-plugin
export default {"danger":"danger___vvgDb"};